module.exports = __webpack_public_path__ + "static/media/file-benefit-icon.92518b42.svg";